import { HStack, VStack } from "@gluestack-ui/themed";
import { ReportCardProps } from "../../types";
import { Text } from "@repo/core/components/core/Text";
import { ReportCardEnum } from "@repo/core/types/reports";

export const NegatedReasonCard = ({
  period,
  total,
  bgColor = "$backgroundLight100",
  values,
  propsByVariant
}: ReportCardProps) => {
  const variantProps = propsByVariant[
    ReportCardEnum.REASON_DENIAL
  ] as (typeof propsByVariant)[ReportCardEnum.REASON_DENIAL];
  if (!variantProps) return null;

  return (
    <VStack
      w="$full"
      p="$4"
      bgColor={bgColor}
      borderBottomWidth={1}
      borderColor="$borderLight100"
    >
      <HStack>
        <VStack flex={1} gap={6}>
          <Text color="$textLight900" fontSize="$sm" fontWeight={600}>
            {period}
          </Text>

          <Text
            color={total?.styles?.color}
            fontSize={total?.styles?.fontSize}
            fontWeight={total?.styles?.fontWeight}
          >
            {total?.label} {total?.value}
          </Text>
          <HStack mt={12} gap="$6">
            <VStack flex={0.6} gap="$2">
              {values.map((value) => {
                return (
                  <HStack alignItems="center" gap="$1">
                    {value.styles?.showIndicator && (
                      <VStack
                        h="$2"
                        w="$2"
                        bg={value.styles?.indicatorColor}
                        borderRadius="$full"
                      />
                    )}
                    <Text color="$textLight700" fontSize="$xs" fontWeight={500}>
                      {value.label} {value.value}
                    </Text>
                  </HStack>
                );
              })}
            </VStack>

            <VStack flex={0.5} gap="$2">
              <HStack alignItems="center" gap="$1">
                <VStack h="$2" w="$2" bg="#18DBB0" borderRadius="$full" />
                <Text color="$textLight900" fontSize="$xs" fontWeight={500}>
                  Outros:
                </Text>
              </HStack>
              {variantProps?.otherValues.map((value) => {
                return (
                  <HStack alignItems="center" gap="$1">
                    {value.styles?.showIndicator && (
                      <VStack
                        h="$2"
                        w="$2"
                        bg={value.styles?.indicatorColor}
                        borderRadius="$full"
                      />
                    )}
                    <Text color="$textLight700" fontSize="$xs" fontWeight={500}>
                      {value.label} {value.value}
                    </Text>
                  </HStack>
                );
              })}
            </VStack>
          </HStack>
        </VStack>
      </HStack>
    </VStack>
  );
};
